import { BaseModel } from './utility.models';
import { IAddress, AddressModel } from './address.models';
import { IStaffModel } from './staff.models';

export interface ITaxRateContainer {
  countyTaxRate: number;
  cityTaxRate: number;
  stateTaxRate: number;
  stadiumTaxRate: number;
  mkeCountyTaxRate: number;
}

export interface ITaxRates {
  salesTax: Array<ITaxRate>;
  useTax: Array<ITaxRate>;
}

export interface ITaxRate {
  name: string;
  rate: number;
}

export interface ILocationModel {
  id: string;
  name: string;
  main: string;
  fax: string;
  requireContractAmount: boolean;
  calculateOutsideServiceTax: boolean;
  address: IAddress;
  staff: Array<IStaffModel>;
  taxRates: Array<ITaxRate>;
  useTaxRates: Array<ITaxRate>;
}

// <editor-fold> Document models

export class LocationModel implements ILocationModel {
    id: string = null;
    name: string = null;
    main: string = null;
    fax: string = null;
    requireContractAmount: boolean = false;
    calculateOutsideServiceTax: boolean = false;
    address: IAddress = new AddressModel();
    staff: Array<IStaffModel> = new Array<IStaffModel>();
    taxRates: Array<ITaxRate> = new Array<ITaxRate>();
    useTaxRates: Array<ITaxRate> = new Array<ITaxRate>();
}

// </editor-fold>
